// src/components/AjustesMenu.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import api from '../services/api';
import { getUserFromStorage } from '../services/auth';

function AjustesMenu() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [mostrarEliminar, setMostrarEliminar] = useState(false);
  const [perfiles, setPerfiles] = useState([]);
  const [seleccionados, setSeleccionados] = useState([]);
  const navigate = useNavigate();

  const perfilActual = JSON.parse(localStorage.getItem('perfilActual'));
  const user = getUserFromStorage();

  useEffect(() => {
    if (mostrarEliminar && user?.id) {
      api.get(`/perfiles/${user.id}`)
        .then(res => {
          const activos = res.data.filter(p => p.activo !== false && p.id !== perfilActual.id);
          setPerfiles(activos);
        })
        .catch(err => console.error('Error cargando perfiles:', err));
    }
  }, [mostrarEliminar, user?.id]);

  const handleCerrarSesion = () => {
    localStorage.removeItem('perfilActual');
    localStorage.removeItem('user');
    navigate('/');
  };

  const handleCambiarPerfil = () => {
    localStorage.removeItem('perfilActual');
    navigate('/SeleccionarPerfil');
  };

  const handleEditarPerfil = () => {
    navigate('/editar-perfil');
  };

  const handlePin = () => {
    if (!perfilActual) return;
    if (perfilActual.pin && perfilActual.pin.length >= 4) {
      navigate('/cambiar-pin');
    } else {
      navigate(`/crear-pin/${perfilActual.id}`);
    }
  };

  const toggleSeleccion = (id) => {
    setSeleccionados(seleccionados.includes(id)
      ? seleccionados.filter(p => p !== id)
      : [...seleccionados, id]
    );
  };

  const handleEliminarSeleccionados = async () => {
    try {
      for (const id of seleccionados) {
        await api.delete(`/perfiles/${id}`);
      }
      setPerfiles(perfiles.filter(p => !seleccionados.includes(p.id)));
      setSeleccionados([]);
      setMostrarEliminar(false);
    } catch (err) {
      console.error('Error eliminando perfiles:', err);
    }
  };

  return (
    <>
      <div style={styles.ajustes}>
        <FiSettings size={30} onClick={() => setMenuAbierto(!menuAbierto)} style={{ cursor: 'pointer' }} />
        {menuAbierto && (
          <div style={styles.menu}>
            <button onClick={handleCambiarPerfil}>Cambiar perfil</button>
            {perfilActual?.es_admin && (
              <>
                <button onClick={() => navigate('/crear-perfil')}>Crear perfil</button>
              </>
            )}
            <button onClick={handleEditarPerfil}>Editar perfil</button>
            <button onClick={handlePin}>
              {perfilActual?.pin && perfilActual.pin.length >= 4 ? 'Cambiar PIN' : 'Crear PIN'}
            </button>
            {perfilActual?.es_admin && (
              <>
                <button onClick={() => setMostrarEliminar(true)}>Eliminar perfil</button>
              </>
            )}
            <button onClick={handleCerrarSesion}>Cerrar sesión</button>
          </div>
        )}
      </div>

      {mostrarEliminar && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalContenido}>
            <h3>Selecciona perfiles para eliminar</h3>
            <div style={styles.filaPerfiles}>
              {perfiles.map(perfil => (
                <div key={perfil.id} style={styles.perfilCard}>
                  <img
                    src={`https://mundiemby.us.to/avatars/${perfil.avatar || 'default.png'}`}
                    alt={perfil.nombre}
                    className="avatar-perfil"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/default-avatar.png';
                    }}
                  />
                  <span style={styles.nombrePerfil}>{perfil.nombre}</span>
                  <input
                    type="checkbox"
                    checked={seleccionados.includes(perfil.id)}
                    onChange={() => toggleSeleccion(perfil.id)}
                  />
                </div>
              ))}
            </div>
            <div style={styles.botonesModal}>
              <button onClick={() => setMostrarEliminar(false)}>Cancelar</button>
              <button
                onClick={handleEliminarSeleccionados}
                disabled={seleccionados.length === 0}
              >
                Confirmar eliminación
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  ajustes: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    color: 'white',
    zIndex: 100
  },
  menu: {
    position: 'absolute',
    top: '40px',
    right: '0px',
    background: '#1e1e1e',
    borderRadius: '10px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    zIndex: 200
  },
  modalBackdrop: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999
  },
  modalContenido: {
    background: '#1e1e1e',
    padding: '2rem',
    borderRadius: '12px',
    maxWidth: '600px',
    width: '90%',
    color: 'white',
    textAlign: 'center'
  },
  filaPerfiles: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '1.5rem',
    marginTop: '1rem'
  },
  perfilCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#222',
    borderRadius: '10px',
    padding: '0.8rem',
    width: '100px'
  },
  nombrePerfil: {
    marginTop: '0.5rem'
  },
  botonesModal: {
    marginTop: '1.5rem',
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center'
  }
};

export default AjustesMenu;
